let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ab2o0")).then(() => parcelRequire('cCw0u'));